module.exports = __webpack_public_path__ + "img/arrowup.743bb6e9.svg";